
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","width":"18","height":"18","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Material-Icons","opacity":".5"}},[_c('g',{attrs:{"id":"checkbox-checked-readonly"}},[_c('path',{attrs:{"id":"Shape","fill":"#7368F0","d":"M16 0H2a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V2a2 2 0 00-2-2zM7 14L2 9l1.41-1.41L7 11.17l7.59-7.59L16 5l-9 9z"}})])])])
          )
        }
      }
    